export default __webpack_public_path__ + "/dist/images/8632969.png";